module.exports = __webpack_public_path__ + "static/media/plus.d7c721b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plus.svg
// module id = 111
// module chunks = 0